import type { EvidenceUploadMode } from 'api';
import { useState } from 'react';
import { useNotification } from '../../../notifications/hooks/useNotification/useNotification';

import { useBulkDeleteEvidence } from '../useBulkDeleteEvidence/useBulkDeleteEvidence';

/**
 * @deprecated
 */
export const useManageEvidence = ({
  mode,
  parentId,
  onSuccess,
  showNotification = true,
}: {
  mode?: EvidenceUploadMode;
  parentId?: string | number;
  onSuccess?: (evidenceIds?: number[]) => void;
  showNotification?: boolean;
}) => {
  const [selected, setSelected] = useState<number[]>([]);
  const { open } = useNotification();
  const { deleteEvidence, isPending } = useBulkDeleteEvidence({
    mode,
    onError: (error) => {
      open({
        message: `Failed to delete evidence: ${error}`,
        type: 'error',
      });
    },
    onSuccess: (evidenceIds) => {
      if (showNotification) {
        open({
          message: `Successfully deleted ${evidenceIds.length} files`,
          type: 'success',
        });
      }
      setSelected([]);
      onSuccess?.(evidenceIds);
    },
    parentId,
  });
  const deleteSelected = () => deleteEvidence({ data: { evidence_ids: selected } });

  return { deleteEvidence, deleteSelected, isPending, selected, setSelected };
};
